import { Component, OnInit, ViewChild } from '@angular/core';
import { SiteService, CommonService } from 'src/app/services/index';
import { MatPaginator, MatTableDataSource } from '@angular/material';
import { MeterModel } from 'src/app/models/index';
@Component({
  selector: 'app-meter-inventory',
  templateUrl: './meter-inventory.component.html',
  styleUrls: ['./meter-inventory.component.scss']
})
export class MeterInventoryComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayAllSiteID = false;
  selectedSite: string;
  meterSources: any;
  // meterData: any;
  siteId: string;
  sites: any;
  meterData: any;
  displayedColumns = ['number', 'meterId', 'loadName', 'make', 'type', 'serialNumber'];
  constructor(private siteService: SiteService, private commonService: CommonService) { }

  ngOnInit() {
    this.getSiteDetails();
    if (localStorage.getItem('isMultipleSites') === 'false') {
      this.displayAllSiteID = false;
      this.selectedSite = localStorage.getItem('siteId');
      this.getMeterDetails();
    } else {
      this.displayAllSiteID = true;
    }
  }
  getSiteDetails() {
    this.siteService.getSiteDetails().subscribe(data => {
      this.sites = data;
    });
  }
  getMeterDetails() {
    if (localStorage.getItem('isMultipleSites') === 'true') {
      this.selectedSite = this.siteId;
    }
    this.siteService.getAllMetersforSiteId(this.selectedSite).subscribe(data => {
      this.meterData = [];
      for (let i = 0; i < data.length; i++) {
        const  model: MeterModel = data[i];
        model.order = i + 1;
        this.meterData.push(model);
      }
      this.meterSources = new MatTableDataSource<MeterModel>(this.meterData);
      this.meterSources.paginator = this.paginator;
    });
  }
}
